import { useEffect, useRef, useState } from 'react';
import { BlogCard, Box, Hidden, IndicatorDots } from '@doist/marketist';
import cn from 'clsx';
import css from './blog-cards.module.css';
export type BlogCardProps = {
  cards: {
    title: string;
    description: string;
    src: string;
    href: string;
    pills: JSX.Element[];
  }[];
};
function BlogCards({
  cards
}: BlogCardProps) {
  const $scrollContainer = useRef<HTMLUListElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  function onSelectIndex(index: number) {
    if ($scrollContainer.current) {
      const scrollWidth = $scrollContainer.current.scrollWidth;
      const itemWidth = scrollWidth / cards.length;
      $scrollContainer.current.scrollTo({
        left: itemWidth * index,
        behavior: 'smooth'
      });
    }
    setActiveIndex(index);
  }
  useEffect(() => {
    const cardContainer = $scrollContainer.current;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const id = entry.target.id.split('-')[1];
          setActiveIndex(Number.parseInt(id, 10));
        }
      }
    },
    // when the li is 100% visible
    {
      root: null,
      rootMargin: '0px',
      threshold: 1
    });
    if (cardContainer) {
      const lis = cardContainer.querySelectorAll('li.column');
      for (const li of lis) observer.observe(li);
    }
    return () => {
      if (cardContainer) {
        const lis = cardContainer.querySelectorAll('li.column');
        for (const li of lis) {
          observer.unobserve(li);
        }
      }
    };
  }, []);
  return <Box className={css.container} data-sentry-element="Box" data-sentry-component="BlogCards" data-sentry-source-file="blog-cards.tsx">
            <Box tag="ul" className={cn(css.horizontalScroll, 'pis-24 lg-pis-0 pbe-16 md-pbe-0')} ref={$scrollContainer} data-sentry-element="Box" data-sentry-source-file="blog-cards.tsx">
                {cards.map((c, i) => <Box tag="li" id={`card-${i}`} key={c.title} className={cn(css.column, 'column')}>
                        <BlogCard {...c} alt="">
                            {c.description}
                        </BlogCard>
                    </Box>)}
            </Box>
            <Hidden above="md" data-sentry-element="Hidden" data-sentry-source-file="blog-cards.tsx">
                <IndicatorDots activeIndex={activeIndex} labels={cards.map(post => post.title)} onSelectIndex={onSelectIndex} data-sentry-element="IndicatorDots" data-sentry-source-file="blog-cards.tsx" />
            </Hidden>
        </Box>;
}
export { BlogCards };